module.exports = __webpack_public_path__ + "static/media/0215_Medium.2bd155b7.jpg";